export default __webpack_public_path__ + "static/media/favourite.d40059d7.svg";